














import { defineComponent, useRouter } from '@nuxtjs/composition-api'
import useFacets from '@/composables/search/useFacets'
import useSearchUrl from '@/composables/search/useSearchUrl'
import { FACETNAMES } from '@/common/static/facets'

export default defineComponent({
  props: {
    facetkey: {
      type: String,
      required: true,
      default: '',
    },
  },

  setup() {
    const router = useRouter()
    const { mapToFacetName, existingFacetIndex, deleteFacet } = useFacets()
    const { getSearchUrl } = useSearchUrl()

    const clearFacet = (name: string) => {
      // Delete the facet
      deleteFacet(name)

      // Perform a search
      router.push(getSearchUrl())
    }

    return {
      mapToFacetName,
      existingFacetIndex,
      clearFacet,
      FACETNAMES,
    }
  },
})
